// project import
import Routes from 'routes';
import ThemeCustomization from 'themes';

import Locales from 'components/Locales';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';
import 'rsuite/dist/rsuite.min.css';
import TenantBranding from 'components/TenantBranding';

// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => (
  <TenantBranding>
    <ThemeCustomization>
      <RTLLayout>
        <Locales>
          <ScrollTop>
            <>
              <Notistack>
                <Routes />
                <Snackbar />
              </Notistack>
            </>
          </ScrollTop>
        </Locales>
      </RTLLayout>
    </ThemeCustomization>
  </TenantBranding>
);

export default App;
